import React from 'react';
import { useSelector } from 'react-redux';
import { NextPage } from 'next';

import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import ErrorPage from '~/pages/_error';
import { getManiaReward } from '~/src/api/promo';
import Layout from '~/src/features/_layout';
import ManiaLayout, { IDealersData } from '~/src/features/mania';
import { initialProps } from '~/src/helpers/basePageFunc';
import { getHostname, selectCompanyName } from '~/src/store/selectors/city';

interface IProps {
    city: ICurrentCity,
    /**
     * Дилерские данные. Мания может быть включена, но информация не заполнена.
     */
    dealersData?: IDealersData,
    companyName: string,
}

const ManiaPage: NextPage<IProps> = ({ city, dealersData, companyName }) => {
    const hostname = useSelector(getHostname);

    const seoDesc = `Провайдер ${companyName} предлагает подключиться к партнерской программе «Дом.ру Мания» в ${city.cityIn}. ` +
        'Получай до 1 500 руб. за каждое подключение. Подробнее на сайте или по ☎  8 (800) 333-70-00';

    if (!dealersData) {
        return <ErrorPage statusCode={404} />;
    }

    return (
        <Layout
            title={`Партнерская программа Дом.ру Мания | Стань дилером Дом.ру в ${city.cityIn}`}
            description={seoDesc}
            withMenu={false}
            withFooter={true}
            withChat={false}
            relCanonical={`https://${hostname}/service/agent`}
            bgColor={COLORS.BgMain}
        >
            <ManiaLayout city={city} dealersData={dealersData}/>
        </Layout>
    );
};

ManiaPage.getInitialProps = async(options) => {
    await initialProps(options);
    const state = options.store.getState();
    const { city: { currentCity, provider: { providerId } } } = state;
    const companyName = selectCompanyName(state);

    const [dealersData] = await getManiaReward(providerId).then(resp => resp.data?.items) || {};

    if (!dealersData && options.res) {
        options.res.statusCode = 404;
    }

    return {
        city: currentCity,
        dealersData,
        companyName,
    };
};

export default ManiaPage;
